import { API } from "aws-amplify";

export async function getSuscripcion() {
  console.log("export async function getSuscripcion()");

  let apiName = process.env.VUE_APP_AWS_API_REST_NAME; // replace this with your api name.
  let path = "/suscripciones"; //replace this with the path you have configured on your API
  let myInit = {
    // OPTIONAL
    headers: {}, // OPTIONAL
    response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
    queryStringParameters: {
      // OPTIONAL
    }
  };
  let result = await API.get(apiName, path, myInit);
  console.log(result);
  return result;
  //return result.data;
}

export async function postSuscripcion(payload) {
  console.log("export async function postSuscripcion(ruc)");

  let apiName = process.env.VUE_APP_AWS_API_REST_NAME; // replace this with your api name.
  let path = "/suscripciones"; //replace this with the path you have configured on your API
  let myInit = {
    body: {
      payload: payload
    }, // replace this with attributes you need
    headers: {
      //Authorization: (await AmplifyModules.Auth.currentSession()).idToken.jwtToken
    } // OPTIONAL
  };
  let result = await API.post(apiName, path, myInit);
  console.log(result);
  return result;

  /*   API.post(apiName, path, myInit)
    .then(response => {
      // Add your code here
      console.log(response);
      if (response.hasOwnProperty("error")) {
        this.setUIMessage(this.$Amplify.I18n.get(response.error), "error");
      } else {
        this.setUIMessage(
          this.$Amplify.I18n.get("La consulta se ha guardado correctamente"),
          "success"
        );
      }
    })
    .catch(error => {
      console.log(error.response);
    })
    .finally(function() {
      that.isLoading = false;
    }); */
}

export async function deleteSuscripcion(payload) {
  console.log("API export async function deleteSuscripcion(selected) {");

  let apiName = process.env.VUE_APP_AWS_API_REST_NAME; // replace this with your api name.
  let path = "/suscripciones"; //replace this with the path you have configured on your API
  let myInit = {
    // OPTIONAL
    headers: {}, // OPTIONAL
    response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
    body: {
      payload: payload
    } // replace this with attributes you need
  };

  await API.del(apiName, path, myInit)
    .then(response => {
      // Add your code here
      console.log(response);
      return response;
    })
    .catch(error => {
      console.log(error.response);
      return error.response;
    });

  //let result = await API.delete(apiName, path, myInit);
  //console.log("resultado:",result);
}
